import api from './axios';

export const getVisitors = async (params) => {
  const response = await api.get('/visitors', { params });
  return response.data;
};

export const getVisitor = async (id) => {
  const response = await api.get(`/visitors/${id}`);
  return response.data;
};

export const createVisitor = async (data) => {
  const response = await api.post('/visitors', data);
  return response.data;
};

export const updateVisitor = async (id, data) => {
  const response = await api.put(`/visitors/${id}`, data);
  return response.data;
};

export const deleteVisitor = async (id) => {
  const response = await api.delete(`/visitors/${id}`);
  return response.data;
};

export const checkInVisitor = async (id, data) => {
  const response = await api.post(`/visitors/${id}/check-in`, data);
  return response.data;
};

export const checkOutVisitor = async (id, data) => {
  const response = await api.post(`/visitors/${id}/check-out`, data);
  return response.data;
};

export const approveVisitor = async (id) => {
  const response = await api.post(`/visitors/${id}/approve`);
  return response.data;
};

export const rejectVisitor = async (id, data) => {
  const response = await api.post(`/visitors/${id}/reject`, data);
  return response.data;
};

export const getCurrentlyInside = async () => {
  const response = await api.get('/visitors/currently-inside');
  return response.data;
};

export const getPreRegistered = async () => {
  const response = await api.get('/visitors/pre-registered');
  return response.data;
};

export const getTodayLog = async () => {
  const response = await api.get('/visitors/today');
  return response.data;
};

export const getVisitorHistory = async (params) => {
  const response = await api.get('/visitors/history', { params });
  return response.data;
};

export const getVisitorReports = async (params) => {
  const response = await api.get('/visitors/reports', { params });
  return response.data;
};
